import { useId } from "react";

export function CdDisc() {
  const serialPathId = useId();

  return (
    <div className="media-disc absolute w-[95%] h-[95%] rounded-full flex items-center justify-center shadow-2xl top-[2.5%] z-0">
      <div className="media-disc-rotor absolute inset-0 rounded-full flex items-center justify-center">
        {/* Base polycarbonate */}
        <div
          className="absolute inset-0 rounded-full"
          style={{
            background:
              "radial-gradient(circle at center, #e0e0e0 0%, #c8c8c8 20%, #d4d4d4 40%, #b8b8b8 60%, #c0c0c0 80%, #d0d0d0 100%)",
          }}
        />
        {/* Data track area - fine grooves */}
        <div
          className="absolute inset-[8%] rounded-full"
          style={{
            background:
              "repeating-radial-gradient(circle at center, transparent 0px, transparent 1px, rgba(0,0,0,0.03) 1.3px, transparent 1.8px)",
          }}
        />
        {/* Asymmetric indexing marks belong to the disc and reveal its rotation. */}
        <div
          className="absolute inset-[9%] rounded-full opacity-45"
          style={{
            background:
              "conic-gradient(from 12deg at center, transparent 0deg 8deg, rgba(45,48,52,0.42) 8deg 10deg, transparent 10deg 112deg, rgba(255,255,255,0.4) 112deg 114deg, transparent 114deg 248deg, rgba(55,58,62,0.35) 248deg 252deg, transparent 252deg 360deg)",
            maskImage:
              "radial-gradient(circle, transparent 0 52%, black 53% 55%, transparent 56% 72%, black 73% 75%, transparent 76%)",
            WebkitMaskImage:
              "radial-gradient(circle, transparent 0 52%, black 53% 55%, transparent 56% 72%, black 73% 75%, transparent 76%)",
          }}
        />
        {/* Inner mirror band (hub area) */}
        <div
          className="absolute w-[40%] h-[40%] rounded-full"
          style={{
            background:
              "radial-gradient(circle at center, transparent 50%, rgba(255,255,255,0.08) 55%, rgba(200,200,200,0.15) 60%, transparent 70%)",
          }}
        />
        {/* Circular matrix/serial microprint around the center hub. */}
        <svg
          aria-hidden="true"
          className="absolute size-[34%] overflow-visible text-zinc-700/70"
          viewBox="0 0 100 100"
        >
          <defs>
            <path id={serialPathId} d="M 50,50 m -35,0 a 35,35 0 1,1 70,0 a 35,35 0 1,1 -70,0" />
          </defs>
          <text fill="currentColor" fontSize="5.5" fontWeight="600" letterSpacing="1.35">
            <textPath href={`#${serialPathId}`} startOffset="2%">
              GARIMPA CD 01 · MATRIX 79A496 · GARIMPA CD 01 ·
            </textPath>
          </text>
        </svg>
        {/* Clear plastic inner ring */}
        <div
          className="absolute w-[22%] h-[22%] rounded-full"
          style={{
            background:
              "radial-gradient(circle at center, transparent 55%, rgba(180,180,180,0.4) 60%, rgba(220,220,220,0.6) 65%, rgba(200,200,200,0.5) 75%, rgba(180,180,180,0.3) 85%, rgba(150,150,150,0.6) 90%, rgba(120,120,120,0.4) 100%)",
            boxShadow: "inset 0 0 4px rgba(0,0,0,0.2)",
          }}
        />
        {/* Center hole */}
        <div
          className="absolute w-[10%] h-[10%] rounded-full"
          style={{
            background: "radial-gradient(circle, #888 0%, #666 40%, #999 60%, #777 100%)",
            boxShadow: "inset 0 1px 3px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.2)",
          }}
        />
        {/* Edge ring */}
        <div
          className="absolute inset-0 rounded-full"
          style={{
            boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.15), inset 0 0 0 2px rgba(0,0,0,0.1)",
          }}
        />
      </div>
      {/* Optical color and room highlights stay fixed as the CD rotates. */}
      <div
        className="pointer-events-none absolute inset-0 rounded-full"
        style={{
          background:
            "conic-gradient(from 28deg at 50% 50%, rgba(255,40,90,0.13), rgba(255,210,40,0.12) 55deg, rgba(30,220,150,0.13) 105deg, rgba(30,130,255,0.13) 165deg, rgba(170,60,255,0.14) 225deg, rgba(255,60,130,0.12) 285deg, rgba(255,40,90,0.13)), radial-gradient(ellipse 58% 38% at 30% 24%, rgba(255,255,255,0.52), rgba(255,255,255,0.12) 34%, transparent 66%), radial-gradient(ellipse 38% 28% at 72% 76%, rgba(255,255,255,0.17), transparent 55%), conic-gradient(from 0deg at center, rgba(255,255,255,0.12), rgba(0,0,0,0.08) 35deg, rgba(255,255,255,0.16) 80deg, rgba(0,0,0,0.06) 145deg, rgba(255,255,255,0.13) 220deg, rgba(0,0,0,0.07) 300deg, rgba(255,255,255,0.12))",
          maskImage: "radial-gradient(circle, transparent 0 11%, black 13% 98%, transparent 100%)",
          WebkitMaskImage:
            "radial-gradient(circle, transparent 0 11%, black 13% 98%, transparent 100%)",
        }}
      />
    </div>
  );
}
